import { yup, validationMessages } from '@medely/ui-kit';

export const marketStepSchema = yup.object({
  zipCode: yup
    .mixed<number | string>()
    .required(validationMessages.zip.required)
    .test('zip5', validationMessages.zip.length, (value) => {
      const digits = String(value ?? '').replace(/\D/g, '');
      return /^\d{5}$/.test(digits);
    }),
  market_ids: yup.array(),
});
